var CONFUSEDCMS = CONFUSEDCMS || {},
    CSSCONSTANTS = CSSCONSTANTS || {};

CONFUSEDCMS.services = CONFUSEDCMS.services || {};

(function (ns, $) {
    'use strict';

    ns.ServiceProxy = function (endpoint) {
        if (!(this instanceof ns.ServiceProxy)) {
            return new ns.ServiceProxy(endpoint);
        }

        var me = this;

        me.endpoint = endpoint;
        
        /**
        * invoke the service proxy using the given options
        *
        * @param {object} options the options
        * @param {string} options.method the method to invoke
        * @param {object | string} options.data data to act as parameter for the remote method
        * @param {function} options.success callback for successful invocation
        * @param {function} [options.error] callback for error on invocation
        * @function
        */
        me.invoke = function(options) {

            if (!options.method) {
                throw new Error('method not specified for service: ' + me.endpoint);
            }
            if (!options.success) {
                throw new Error('success handler not supplied for service: ' + me.endpoint);
            }

            var url = '/' + me.endpoint + '/' + options.method; // + '?t=' + Date.now();
            console.log(options.data);
            var data = typeof options.data === 'object' ? JSON.stringify(options.data) : options.data;

            me.xhr = $.ajax({
                type: 'POST',
                url: url,
                data: data,
                contentType: 'json',
                //handles stupid MS JSON format!!
                converters: {
                    'text json': function(result) {
                        var msg = (window.JSON && window.JSON.parse) ? JSON.parse(result) : $.parseJSON('(' + result + ')');

                        return msg.hasOwnProperty('d') ? msg.d : msg;
                    }
                },
                error: function(jqXhr, textStatus, errorThrown) {
                    if (options.error) {
                        options.error(jqXhr, textStatus, errorThrown);
                    }
                },
                success: function(result, textStatus, jqXhr) {
                    options.success(result, textStatus, jqXhr);
                }
            });
        };
    };
    
    /**
    * Helper for recording client-side MI events
    *
    * @constructor 
    */
    ns.MiService = function () {
        if (!(this instanceof ns.MiService)) {
            return new ns.MiService();
        }
        
        var proxy = new ns.ServiceProxy('miv2');

        /**
        * Records the given event information against the given event
        *
        * @param {object} event the event object
        * @param {string} event.EventType eventTye
        * @param {string} event.EventInfo eventInfo
        * @param {object} event.Context any additional data
        * @param {object} options any additional options
        * @param {function} options.success success callback
        * @function
        */
        this.pageEvent = function(event, options) {
            var settings = $.extend({}, options, {
                method: 'Event',
                data:  event,
                success: $.noop //don't care about success with MI
            });
            proxy.invoke(settings);
        };
    };
}(CONFUSEDCMS.services, jQuery));

    